import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';

/**
 * 0040. サインイン
 * [POST] /sign_in
 */
type Props = {
  email?: string;
  password?: string;
  id_token?: string;
  invitation: string | null;
};

const signIn = (params: Props): Promise<any> => {
  return axios.post(`/api/sign_in`, params);
};

export const useSignIn = () => {
  return useMutation({
    mutationFn: signIn,
  });
};
